import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {Title} from '@angular/platform-browser';

@Component({
  selector: 'app-edit-user',
  templateUrl: './edit-user.component.html'
})
export class EditUserComponent implements OnInit {
  uuid: string;

  constructor(private route: ActivatedRoute, private titleService: Title) {
    this.uuid = this.route.snapshot.paramMap.get('uuid');
  }

  ngOnInit() {
    this.titleService.setTitle('Arvest Business Partner Portal: Edit User');
  }

}
